import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  container: {
    padding: '2.5cm 2cm 2.5cm 2cm',
  },
});
